// extracted by mini-css-extract-plugin
module.exports = {"container":"PageBanner_container__iCej3","titleContainer":"PageBanner_titleContainer__pqqGD"};